// @flow

import styled from "styled-components";

import * as colors from "src/styles/constants/colors";
import * as size from "src/styles/constants/size";
import * as spacing from "src/styles/constants/spacing";

export const DownloadButton = styled.span`
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg > path {
    fill: ${colors.lightBlue600};
  }
`;

export const FileDataHeader = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
`;

export const FileGridList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(181px, auto));
  justify-content: start;
  gap: 0.5rem;
  width: 100%;
  overflow: hidden;
`;

export const FileWrapper = styled.div`
  display: flex;
  cursor: pointer;
  border: 1px solid ${colors.grey41};
  border-radius: 4px;
  padding: 8px;
  background-color: ${colors.brightLight};
  width: 181px;
  overflow: hidden;
  gap: 8px;
  :hover {
    background-color: ${(props) => props.hoverBg};
    .download-button {
      visibility: visible;
    }
  }
`;

export const FileIconWrapper = styled.div`
  padding: ${spacing.space_xs};
  display: flex;
  align-items: center;
  svg,
  img,
  div {
    width: 36px;
    height: 36px;
    margin: 0;
  }
`;

export const FileSize = styled.div`
  font-size: ${size.fontSize.small};
  line-height: 12px;
  color: ${colors.grey42};
`;
